import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { propTypes as reduxFormPropTypes, reduxForm } from 'redux-form';
import EditSelectionForm from '../../common/components/EditSelectionForm';

const validate = (values, props) => {
  const errors = {};
  const field = 'name';

  if (props.checkedMailboxes && !props.checkedMailboxes.length) {
    errors[field] = (
      <div id="no-mailbox-selected">
        <FormattedMessage id="app.no.mailbox.selected" />
      </div>
    );
  }

  return errors;
};

// eslint-disable-next-line react/prefer-stateless-function
class EditMailboxSelectionFormContainer extends Component {
  render() {
    const {
      onCloseModal,
      handleSubmit,
      name,
      errorMessage,
    } = this.props;

    return (<EditSelectionForm
      onCloseModal={onCloseModal}
      handleSubmit={handleSubmit}
      errorMessage={errorMessage}
      name={name}
    />);
  }
}

EditMailboxSelectionFormContainer.propTypes = {
  ...reduxFormPropTypes,
  onCloseModal: PropTypes.func.isRequired,
  name: PropTypes.string,
};

export default reduxForm({
  form: 'saveSelection',
  validate,
})(EditMailboxSelectionFormContainer);
